import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";

export function useVisualViewportHeight() {
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const showListener = Keyboard.addListener(
      "keyboardWillShow",
      (info) => {
        setHeight(window.innerHeight - info.keyboardHeight);
      },
    );

    const hideListener = Keyboard.addListener("keyboardWillHide", () => {
      setHeight(window.innerHeight);
    });

    return () => {
      showListener.then((h) => h.remove());
      hideListener.then((h) => h.remove());
    };
  }, []);

  return height;
}
